import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM } from '@sorare/core/src/atoms/typography';
import { NeonEdge } from '@sorare/core/src/atoms/ui/NeonEdge';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

import draw from 'components/essence/CardPullExperience/CardPullRulesDialog/HowItWorks/assets/draw.png';

const Content = styled(Vertical)`
  height: 100%;
  padding: var(--triple-unit) var(--quadruple-unit) 0;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const StyledNeonEdge = styled(NeonEdge)`
  position: absolute;
  inset: 0;
`;

const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

export const DrawCards = () => {
  const { currentUser } = useCurrentUserContext();
  const threshold = currentUser?.shardsChests?.find(
    chest => chest.rarity === Rarity.limited
  )?.thresholds?.[0]?.threshold;
  return (
    <Bezel borderColor="rgba(var(--c-rgb-limited), 0.3)">
      <StyledTextureBackground
        background="wave2"
        mode="dark"
        color={['var(--c-black)', 'rgba(var(--c-rgb-black), 0)']}
        imageOpacity={0.3}
        withDots
      />
      <Content center gap={4}>
        <Vertical center>
          <FormattedMessage
            id="DrawCards.title"
            defaultMessage="<em>Draw 10 Cards</em><label>for {count} Essence</label>"
            values={{
              em: chunks => <BrandM>{chunks}</BrandM>,
              label: chunks => <BodyM color="var(--c-nd-600)">{chunks}</BodyM>,
              count: <FormattedNumber value={threshold || 1000} />,
            }}
          />
        </Vertical>
        <Img src={draw} alt="" />
      </Content>
      <StyledNeonEdge
        color="var(--c-limited-primary)"
        showNeon="always"
        showHalo="always"
      />
    </Bezel>
  );
};
